import { isNeString } from '@aretheyhappy/utils';
export class FrontendLogger {
    /**
     * Set values that should be allowed to log at this time.
     * @param values
     */
    static setAllowedLogValues(values) {
        this.allowed_log_values = values;
    }
    /**
     * Allow all logs
     * @param value
     */
    static setAllowAllLogs(value) {
        this.allow_all_logs = value;
    }
    static isAllowedLog(message) {
        for (const allowed_value of this.allowed_log_values) {
            if (isNeString(allowed_value) &&
                message.toLowerCase().includes(allowed_value.toLowerCase()))
                return true;
        }
        return false;
    }
    static info(message, ...optionalParams) {
        if (!isNeString(message))
            return;
        if (!this.allow_all_logs &&
            !this.isAllowedLog(message))
            return;
        console.info(message, ...optionalParams);
    }
    static log(message, ...optionalParams) {
        if (!isNeString(message))
            return;
        if (!this.allow_all_logs &&
            !this.isAllowedLog(message))
            return;
        // eslint-disable-next-line no-console
        console.log(message, ...optionalParams);
    }
    static warn(message, ...optionalParams) {
        if (!isNeString(message))
            return;
        if (!this.allow_all_logs &&
            !this.isAllowedLog(message))
            return;
        console.warn(message, ...optionalParams);
    }
    static error(message, ...optionalParams) {
        if (!isNeString(message))
            return;
        if (!this.allow_all_logs &&
            !this.isAllowedLog(message))
            return;
        console.error(message, ...optionalParams);
    }
}
// If all logs should be allowed
FrontendLogger.allow_all_logs = false;
// If only certain values should be allowed to be logged
FrontendLogger.allowed_log_values = [];
//# sourceMappingURL=FrontendLogger.js.map